import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import Login from './pages/Login';
import Learn from './pages/Learn';
import Complete from './pages/Complete';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import UserManage from './pages/admin/UserManage';
import DepartmentManage from './pages/admin/DepartmentManage';
import ContentManage from './pages/admin/ContentManage';
import QuestionManage from './pages/admin/QuestionManage';
import FillBlankManage from './pages/admin/FillBlankManage';
import Statistics from './pages/admin/Statistics';
import LoginLog from './pages/admin/LoginLog';
import PromiseManage from './pages/admin/PromiseManage';
import { AuthProvider } from './utils/auth';
import { PrivateRoute, AdminRoute } from './components/ProtectedRoutes';
import AdminLayout from './components/AdminLayout';

function App() {
  return (
    <ConfigProvider locale={zhCN}>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <AuthProvider>
          <Routes>
            {/* 员工端路由 */}
            <Route path="/login" element={<Login />} />
            <Route path="/learn" element={
              <PrivateRoute>
                <Learn />
              </PrivateRoute>
            } />
            <Route path="/complete" element={
              <PrivateRoute>
                <Complete />
              </PrivateRoute>
            } />
            
            {/* 管理后台路由 */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
            <Route element={
              <AdminRoute>
                <AdminLayout />
              </AdminRoute>
            }>
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/admin/users" element={<UserManage />} />
              <Route path="/admin/departments" element={<DepartmentManage />} />
              <Route path="/admin/contents" element={<ContentManage />} />
              <Route path="/admin/questions" element={<QuestionManage />} />
              <Route path="/admin/fillblanks" element={<FillBlankManage />} />
              <Route path="/admin/statistics" element={<Statistics />} />
              <Route path="/admin/promises" element={<PromiseManage />} />
              <Route path="/admin/login-logs" element={<LoginLog />} />
            </Route>
            
            {/* 默认路由 */}
            <Route path="/" element={<Navigate to="/login" replace />} />
          </Routes>
        </AuthProvider>
      </Router>
    </ConfigProvider>
  );
}

export default App;
